import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { filtersModalId: String }

  openFilters(event) {
    event.preventDefault()

    const modal = document.getElementById(this.filtersModalIdValue)
    modal.classList.remove('closed')
  }
}
